<section class="anonymous">
  <div class="anonymous-avatar" [style.width]="widthStyle" [style.height]="heightStyle">
    <span>{{ text }}</span>
  </div>
  <div class="anonymous-name">
    <div>匿名</div>
  </div>
</section>
